import {useHistory} from "react-router-dom";
import {useAuth} from "../authprovider";
import React, {useState} from "react";
import {Alert, Button, Card, Form} from "react-bootstrap";
import {useTranslation} from 'react-i18next';

import '../css/Login.css';


export default function LoginPage() {
    let history = useHistory();
    let auth = useAuth();
    const { t } = useTranslation();

    let [password, setPassword] = useState("")
    let [login, setLogin] = useState("")
    let [alert, setAlert] = useState({
        show:false,
        content:"",
        variant:"",
        title:""
    })



    let handleSubmit = (event)=>{
        event.preventDefault();

        auth.signin(login, password, (result) => {

            if(result.success) {
                history.entries = [];
                history.index = -1;
                history.push(`/`);
            }
            else
                showAlert(t('login.errorInvalidCredentials'), t('login.errorInvalidCredentialsTitle'))
        });
    }

    let handleInputChange = (event)=>{
        const target = event.target;
        const value = target.value;
        const name = target.name;

        if(name === "login")
            setLogin(value)
        else
            setPassword(value)
    }

    let showAlert = (content, title)=>{
        setAlert({
            show:true,
            content:content,
            variant:"warning",
            title:title
        })
    }

    let hideAlert = ()=>{
        setAlert({
            show:false,
            content:"",
            variant:"",
            title:""
        })
    }

    return (
        <Card className={"m-2 p-4 w-50 loginCard"} key={"data"}>
            <div >

                <Form action={"post"} onSubmit={handleSubmit} >
                    <Alert show={alert.show} variant={alert.variant} onClose={hideAlert} dismissible>
                        <p>
                            {alert.content}
                        </p>
                    </Alert>
                    <Form.Group size="lg" controlId="email">
                        <Form.Label>{t('login.loginLabel')}</Form.Label>
                        <Form.Control
                            autoFocus
                            type="text"
                            name="login"
                            value={login}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                    <Form.Group size="lg" controlId="password">
                        <Form.Label>{t('login.passwordLabel')}</Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            value={password}
                            onChange={handleInputChange}
                        />
                    </Form.Group>
                    <Button name={"Zaloguj"} block={"block"} size="lg" type="submit" className={'mt-4'}>
                        {t('login.submit')}
                    </Button>
                </Form>
            </div>
        </Card>
    );
}